import type { ReactNode } from 'react'
import Typography from '@mui/material/Typography'
import MuiDialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Close from '@mui/icons-material/Close'

const classes = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}

interface DialogTitleProps {
  title?: string
  onClose?: () => void
  actions?: ReactNode
}
/**
 * Simple title for modal dialogs
 * @param title - title itself
 * @param onClose - callback to call if the 'close' button clicked (hidden if no callback provided)
 * @param actions - optional controls shown on the title row, left of the close button
 */
const DialogTitle = ({ title, onClose, actions }: DialogTitleProps) => {
  return (
    <MuiDialogTitle sx={classes.root}>
      <Typography variant="h2" component="span">
        {title || null}
      </Typography>
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        {actions}
        {!!onClose && (
          <IconButton aria-label="close" onClick={onClose} edge="end">
            <Close />
          </IconButton>
        )}
      </Stack>
    </MuiDialogTitle>
  )
}

export default DialogTitle
